<template>
  <el-menu style="overflow: hidden;height: 60px" :default-active="activeIndex" mode="horizontal">
    <el-submenu index="0">
      <template slot="title">修行</template>
      <el-menu-item v-for="item in curriculum" :key="item.id" v-on:click="openCurriculum(item.id)">
        {{ item.name }}
      </el-menu-item>
    </el-submenu>
    <el-submenu index="1" disabled>
      <template slot="title"><a v-on:click="$router.push('/search')">情报</a></template>
      <el-menu-item v-for="item in news" :key="item.id">
        {{ item.name }}
      </el-menu-item>
    </el-submenu>
    <el-submenu index="2" disabled>
      <template slot="title"><a v-on:click="$router.push('/search')">万物生态</a></template>
      <el-menu-item v-for="item in everything" :key="item.id">
        {{ item.name }}
      </el-menu-item>
    </el-submenu>
    <el-menu-item disabled>短片</el-menu-item>
    <el-menu-item v-on:click="goNewTabPage('https://blt.qa.pjcgart.com/')">BLT</el-menu-item>
    <el-menu-item v-on:click="goNewTabPage('https://shop143025316.taobao.com/')">捐赠</el-menu-item>
    <el-menu-item v-on:click="$router.push('/about')">联系我们</el-menu-item>
  </el-menu>
</template>

<script>
import AxiosBase from "@/components/axiosBase";

export default {
  name: "HeaderMenu",
  data() {
    return {
      activeIndex: '0',
      curriculum: [],
      news: [
        {
          name: '版本亮点',
        },
        {
          name: '焦点关注',
        },
        {
          name: '最新教学',
        },
        {
          name: '插件评测',
        }
      ],
      everything: [
        {
          name: '插件'
        },
        {
          name: 'HDRI'
        },
        {
          name: '纹理'
        },
        {
          name: '模型'
        },
        {
          name: '灯光'
        },
      ]
    };
  },
  beforeMount() {
    AxiosBase.axiosGet("/curriculum/base").then(response => {
      if (response !== 0) {
        this.curriculum = response.data
      }
    })
  },
  methods: {
    goNewTabPage(target) {
      window.open(target, '_blank');
    },
    openCurriculum(id) {
      window.open(this.$router.resolve("/curriculum/" + id).href)
    }
  }
}
</script>

